<template>
  <div>
    <div class="textmobile-banner" style="display: block;">
      <van-image src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/zt/hhyf-duanwu/zq.jpg"></van-image>
    </div>
    <div class="textmobile-content">
      <div id="test-editormd-view" class="markdown-body editormd-html-preview">
        <p>
          <router-link :to="{ path: 'topic-list' }">
            <van-image alt=""
              src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/zt/hhyf-duanwu/1650270321duihuan.png"></van-image>
          </router-link>
          <router-link :to="{ path: 'order-list', query: { orderType: 'mall' } }">
            <van-image alt=""
              src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/zt/hhyf-duanwu/1650270393chaxun.png"></van-image>
          </router-link>
          <router-link :to="{ path: 'user-center-update-pwd' }">
            <van-image alt=""
              src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/zt/hhyf-duanwu/pwd.png"></van-image>
          </router-link>

          <a :href="$wx_kefu_rc()">
            <van-image alt=""
              src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/zt/hhyf-duanwu/16475939044.jpg"></van-image>
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { $wx_kefu_rc } from "@/util/wxSdk"

export default {
  name: "hhyf-duanwu",

  methods: {
    $wx_kefu_rc: $wx_kefu_rc,

    forbidBack() {
      window.history.pushState('forward', null, '#');
      window.history.forward(1);
    },
  },

  mounted() {
    if (window.history && window.history.pushState) {
      window.addEventListener('popstate', this.forbidBack, false);
      this.forbidBack()
    }
  },

  destroyed() {
    window.removeEventListener('popstate', this.forbidBack, false);
  },
}
</script>

<style scoped>
.textmobile-banner {
  display: none;
  width: 100%;
}

.textmobile-banner img {
  max-width: 100%;
  display: block;
  margin: 0 auto;
}

.textmobile-content {
  padding: 8px;
}

.editormd-preview-container,
.editormd-html-preview {
  width: auto;
}
</style>
